var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06135 13.1661C1.72802 13.1661 1.4437 13.0461 1.2084 12.806C0.973113 12.5659 0.855469 12.2794 0.855469 11.9462C0.855469 11.613 0.973113 11.3288 1.2084 11.0936L5.29663 7.00738L1.2084 2.93584C0.973113 2.69086 0.855469 2.40669 0.855469 2.08332C0.855469 1.74035 0.973113 1.45372 1.2084 1.22344C1.4437 0.993167 1.72802 0.878028 2.06135 0.878028C2.38487 0.878028 2.66918 0.990719 2.91428 1.2161L7.01722 5.30233L11.1495 1.20139C11.3848 0.96622 11.6643 0.848633 11.9878 0.848633C12.3211 0.848633 12.6054 0.96622 12.8408 1.20139C13.0761 1.43658 13.1937 1.72076 13.1937 2.05392C13.1937 2.38709 13.0761 2.67617 12.8408 2.92115L8.73784 7.00738L12.826 11.079C13.0613 11.2945 13.179 11.5836 13.179 11.9462C13.179 12.2794 13.0613 12.5659 12.826 12.806C12.5908 13.0461 12.3016 13.1661 11.9585 13.1661C11.6055 13.1661 11.3163 13.0485 11.0908 12.8133L7.01722 8.72716L2.9584 12.8133C2.7133 13.0485 2.41429 13.1661 2.06135 13.1661Z",
    fill: "#7B7465"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.738ba0c599b3875e30f0d91e02683451.svg";
export { ForwardRef as ReactComponent };